{
  "Announcements": "Anúncios",
  "MarkAllAsRead": "Marcar tudo como lido",
  "NoLinkNotification": "Nenhum link disponível para essa notificação",
  "Notification": "Notificações",
  "ViewAll": "Exibir tudo"
}
